import React from "react";
import Typography from "@material-ui/core/Typography";
const PointOfSales = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Point Of Sales
      </Typography>
      <Typography paragraph variant="h5">
        Sell the product in retail way using Point of Sale (B2C)
      </Typography>
      <Typography paragraph variant="body1">
        Point Of Sales is one of the features under the Sales module to perform
        sales transactions particularly in retail way. It contains any
        information regarding the Point Of Sales transaction history, and the
        form to make the sales transaction.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How it works
      </Typography>
      <Typography paragraph variant="body1">
        The first information displayed on this feature is the Point Of Sales
        form under the tab Point Of Sales. There are 2 sections in this form,
        the left side is the items to be sold, and the right side is the
        payment. There are 3 options to sell the items: Scan by Barcode, Search
        By Item Name, or Click the Item Image. The other feature in this Point
        Of Sales is the sales history under the tab Sales List.
      </Typography>
    </React.Fragment>
  );
};

export default PointOfSales;
